// External deps
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';

// Internal deps
import { getMessages } from '../adapters/requestServiceDetails/requestServiceDetailsAdapter';
import LoaderContext from '../context/LoaderProvider';

import useToast from './useToast';

const useMessage = (isMonthly) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [error, setError] = useState(false);
  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();
  const { id } = useParams();

  const getListMessages = () => {
    if (!pageIndex) {
      setLoader(true);
    }
    setLoading(true);
    const skip = pageIndex + 1;

    getMessages(id, skip, isMonthly)
      .then((res) => {
        const reversedItems = res.items.reverse();

        setMessages([...reversedItems, ...messages]);
        setPageIndex(res.pageIndex);
        setHasNextPage(res.totalPages ? res.pageIndex !== res.totalPages : false);
        setLoader(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoader(false);
        setLoading(false);
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
        setError(true);
      });
  };

  const refreshInitMessages = () => {
    setLoading(true);
    const skip = 1;

    getMessages(id, skip, isMonthly)
      .then((res) => {
        const reversedItems = res.items.reverse();

        setMessages([...reversedItems]);
        setPageIndex(res.pageIndex);
        setHasNextPage(res.pageIndex !== res.totalPages);
        setLoader(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoader(false);
        setLoading(false);
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
        setError(true);
      });
  };

  return {
    loading,
    messages,
    hasNextPage,
    error,
    loadMore: getListMessages,
    refreshInitMessages
  };
};

export default useMessage;
